import React from 'react';

const PortfolioPostIntro = () => {
    return (
        <section>
            <div className="stg-row stg-bottom-gap-l stg-tp-bottom-gap">
                <div className="stg-col-6 stg-tp-bottom-gap">
                    <h1 className="infocolors-post-title" data-appear="fade-up" data-unload="fade-left">Curology</h1>
                </div>
                <div className="stg-col-6 stg-tp-col-9 stg-tp-offset-3 align-right" data-appear="fade-up" data-delay="100" data-unload="fade-right">
                    <p>Beyond formulas: Building a brand that speaks to skin, soul, and science. Collaborating with Curology to create a transformative skincare experience, from brand identity to customer connection.</p>
                </div>
            </div>
        </section>
    );
};

export default PortfolioPostIntro;
